<template>
  <div class="animated fadeIn">
    <h4 class="page-title">Assignment of Cleaners</h4>
    <hr >
    <b-row>
      <b-col md="6">
        <b-btn
          v-show="!isFetching"
          :disabled="isPosting"
          variant="primary"
          class="float-left"
          type="button"
          @click="submitAssignment">
          <i
            v-show="isPosting"
            class="fa fa-spinner fa-spin">&nbsp;</i>
          Assign Cleaners
        </b-btn>
      </b-col>
    </b-row>

    <spinner v-if="isFetching" />

    <b-row v-if="!isFetching">
      <b-col md="12">
        <div
          v-for="(zone, index) in joinedData"
          :key="zone.CODE"
          class="mt-3">
          <b-btn
            :class="[zone.COLLAPSED ? null : 'collapsed']"
            :aria-controls="zone.CODE"
            :aria-expanded="zone.COLLAPSED ? 'true' : 'false'"
            class="text-left"
            block
            variant="secondary"
            size="lg"
            @click="toggleCollapse(index)">
            <span>
              <i :class="[zone.COLLAPSED ? 'icon-minus' : 'icon-plus']"/> {{ zone.NAME }}
            </span>
          </b-btn>
          <b-collapse
            :id="zone.CODE"
            v-model="zone.COLLAPSED">
            <station-view
              :stations="zone.STATIONS"
              :zone="zone" />
          </b-collapse>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { Spinner } from '@/components'
import StationView from './StationView'
import { toastr } from '@/services/'
import { mapState } from 'vuex'

export default {
  name: 'Assignment',
  components: {
    StationView,
    Spinner
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapState('assignment', [
      'isFetching',
      'joinedData',
      'isPosting'
    ]),
    showStation (zone) {
      return !zone.COLLAPSED
    }
  },
  created () {
    this.$store.commit('assignment/setIsFetching', true)
    Promise.all([
      this.$store.dispatch('assignment/fetchZones'),
      this.$store.dispatch('assignment/fetchStations'),
      this.$store.dispatch('assignment/fetchCars'),
      this.$store.dispatch('assignment/fetchCarInStations'),
      this.$store.dispatch('assignment/fetchCleaners'),
      this.$store.dispatch('assignment/fetchAssignments')
    ]).then(() => {
      // compose data structure
      this.$store.dispatch('assignment/composeData')
      this.$store.commit('assignment/setIsFetching', false)
    }, () => {
      toastr.serverError()
    })
  },
  methods: {
    toggleCollapse (idx) {
      this.$store.commit('assignment/toggleZone', {idx: idx})
    },
    submitAssignment () {
      this.$store.commit('assignment/setIsPosting', true)
      // put dispatch in timeout to give submit animation a breather
      setTimeout(() => {
        this.$store.dispatch('assignment/submitAssignment').then(
          () => {
            toastr.success()
            this.$store.commit('assignment/setIsPosting', false)
          },
          err => {
            this.$store.commit('assignment/setIsPosting', false)
            if (err.formInvalid) {
              toastr.error(err.msg)
            } else {
              toastr.serverError()
            }
          }
        )
      }, 200)
    }
  },
}
</script>
